"use strict";

exports.__esModule = true;
exports.TargetPopoverContent = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _Theme = require("../../../Theme");
var _icons = require("@blueprintjs/icons");
var _Core = require("../../../Core");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SaveButton = _styledComponents["default"].div.withConfig({
  displayName: "TargetPopoverContent__SaveButton",
  componentId: "sc-joq3p3-0"
})(["display:flex;justify-content:flex-end;padding:20px;padding-top:0px;"]);
var TargetPopoverContent = exports.TargetPopoverContent = function TargetPopoverContent(props) {
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var target = props.target,
    onSubmit = props.onSubmit;
  var _useState = (0, _react.useState)(target),
    targetValue = _useState[0],
    setTargetValue = _useState[1];
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    _react["default"].createElement("div", {
      style: {
        backgroundColor: (0, _Theme.val)("background")
      },
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      onKeyDown: function onKeyDown(e) {
        return e.stopPropagation();
      },
      className: _core.Classes.POPOVER_CONTENT,
      "data-testid": "TargetPopoverContent.div"
    }, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("TargetPopoverContent.label", "Add target value"),
      style: {
        padding: "20px",
        paddingBottom: "0px"
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.InputGroup, {
      value: targetValue,
      onChange: function onChange(e) {
        return setTargetValue(e.target.value);
      }
    })), /*#__PURE__*/_react["default"].createElement(SaveButton, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      icon: _icons.IconNames.FLOPPY_DISK,
      intent: _core.Intent.PRIMARY,
      onClick: function onClick() {
        onSubmit(targetValue);
      },
      className: _core.Classes.POPOVER_DISMISS,
      "data-testid": "TargetPopoverContent.save.button"
    }, translate("TargetPopoverContent.button.save", "Save"))))
  );
};